import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ForeignKeyValidator } from 'src/app/components/core/_infrastructure/classes/foreignKeyValidator';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { NoWhiteSpaceValidator } from 'src/app/components/core/_infrastructure/classes/noWhiteSpaceValidator';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { VariedadService } from '../variedad.service';
import { TVariedadViewModel } from '../variedad.types';
@Component({
    selector: 'app-variedad-wrapper-edit',
    templateUrl: './variedad-wrapper-edit.component.html',
    styleUrls: ['./variedad-wrapper-edit.component.scss'],
})
export class VariedadWrapperEditComponent extends ComponentBase implements OnInit {
    /**
     * @article: Reactive forms with smart dumb components
     * https://medium.com/angular-athens/reactive-forms-with-smart-dumb-components-48ebc81417c7
     */

    visibilitySpinner = false;
    variedad: TVariedadViewModel;
    formGroup: FormGroup;

    private messageErrorAlreadyExist = 'Ya existe esta combinación de Variedad y Especie';
    private successMessage = 'Variedad modificada correctamente';
    private listUrl = '/mantenimiento/especies/variedades';

    private activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getVariedad(id);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private variedadService: VariedadService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    ngOnInit(): void {
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                Descripcion: [null, Validators.compose([Validators.required, NoWhiteSpaceValidator.cannotContainSpace])],
                Activo: [true, Validators.required],
                IdEspecie: [null, ForeignKeyValidator.cannotBeNullOrZero],
                Grupo: ['', Validators.required],
                Forma: [''],
                CodigoEppo: [''],
                IdNombreCientifico: [null],
                NombreCientifico: [''],
                NombreComun: [''],
                HabilitadaImportacion: [false],
                HabilitadaExportacion: [false],
                HabilitadaChina: [false],
            }),
        });
    }

    private getVariedad(id: number): void {
        this.variedadService
            .getVariedad(id)
            .pipe(
                tap((v: TVariedadViewModel) => {
                    this.variedad = v;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSave(): void {
        this.visibilitySpinner = true;
        const model = { ...this.formGroup.value.basic };

        this.variedadService
            .saveVariedad(model)
            .pipe(
                tap(res => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error?.message?.indexOf(this.messageErrorAlreadyExist) != -1) {
                        this.formGroup.disable();
                    }
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
